var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-carousel-container"
  }, [_c('b-carousel', {
    attrs: {
      "id": "carousel-1",
      "interval": 8000,
      "controls": "",
      "indicators": "",
      "img-width": "1024",
      "img-height": "480"
    },
    on: {
      "sliding-start": _vm.onSlideStart,
      "sliding-end": _vm.onSlideEnd
    },
    model: {
      value: _vm.slide,
      callback: function callback($$v) {
        _vm.slide = $$v;
      },
      expression: "slide"
    }
  }, [_c('b-carousel-slide', {
    scopedSlots: _vm._u([{
      key: "img",
      fn: function fn() {
        return [_c('div', {
          staticClass: "rep-dash-bg"
        }, [_c('div', {
          staticClass: "mb-2"
        }, [_c('img', {
          attrs: {
            "src": require("../../assets/images/rep.svg"),
            "alt": "Representative Dashboard"
          }
        })]), _c('h5', [_vm._v("Representative Dashboard")]), _c('p', {
          staticClass: "rep-txt"
        }, [_vm._v(" Experience seamless management of your broker reps, members, and employer groups. Join our platform for real-time insights and simplified operations. ")])])];
      },
      proxy: true
    }])
  }), _c('b-carousel-slide', {
    scopedSlots: _vm._u([{
      key: "img",
      fn: function fn() {
        return [_c('div', {
          staticClass: "rep-dash-bg"
        }, [_c('div', {
          staticClass: "mb-2"
        }, [_c('img', {
          attrs: {
            "src": require("../../assets/images/scan.svg"),
            "alt": "QR Login"
          }
        })]), _c('h5', [_vm._v("Login with QR")]), _c('p', {
          staticClass: "rep-txt"
        }, [_vm._v(" Login faster and securely by scanning the QR code with your mobile device. Enjoy access to your representative dashboard without the need for a password. ")])])];
      },
      proxy: true
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }